import React, { memo } from "react";
import * as PropTypes from "prop-types";
import PivotTable from "../../table/PivotTable";

const CurrentSpendingBySectorTable = props => (
  <PivotTable
    reference="1.1"
    caption="Current Spending by Sector"
    subcaption="Segmented by GNI Group"
    titles={[
      {
        key: "areas",
        title: "",
        columnSpan: 1
      },
      {
        key: "total",
        title: "",
        columnSpan: 1,
        groupEnd: true
      },
      {
        key: "public",
        title: "",
        columnSpan: 1,
        total: true
      },
      {
        title: "Within Public",
        columnSpan: 2,
        groupEnd: true
      },
      {
        key: "private",
        title: "",
        columnSpan: 1,
        total: true
      },
      {
        title: "Within Private",
        columnSpan: 2
      }
    ]}
    columnKey="sector"
    columnDefinitions={[
      {
        value: "Total",
        groupEnd: true
      },
      {
        value: "Public",
        total: true
      },
      {
        value: "Donor"
      },
      {
        value: "Government",
        groupEnd: true
      },
      {
        value: "Private",
        total: true
      },
      {
        value: "Private Sub",
        label: "Subsidized"
      },
      {
        value: "Private Non-Sub",
        label: "Non-Subsidized"
      }
    ]}
    rowKey="area"
    rowDefinitions={[
      {
        value: "Low-Income (LIC)",
        label: "LIC"
      },
      {
        value: "Lower-Middle-Income (L-MIC)",
        label: "L-MIC"
      },
      {
        value: "Upper-Middle-Income (U-MIC)",
        label: "U-MIC"
      },
      {
        value: "Total",
        label: "Total",
        total: true
      }
    ]}
    data={props.data}
  />
);

CurrentSpendingBySectorTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(CurrentSpendingBySectorTable);
